import { Amplify } from "aws-amplify";
import { env } from "../../env";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
      userPoolId: env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
    },
  },
});

export const awsConfig = Amplify.getConfig();
